import { callApi } from "utils/ContentoApi"

import type { RecentCustomInstruction } from "./types"

export const fetchRecentCustomInstructions = async (accountId: string): Promise<RecentCustomInstruction[]> => {
  const { recentCustomInstructions } = await callApi(
    { method: "get", url: `content-factory/accounts/${accountId}/postBatches/recentCustomInstructions` },
    true,
    true,
  )
  return recentCustomInstructions
}
